import React, {useMemo} from 'react';
import {
    PROSPECT_BUSINESS_ADD,
    PROSPECT_BUSINESS_FORM,
    PROSPECT_INDIVIDUAL_ADD,
    PROSPECT_INDIVIDUAL_FORM
} from "v4/data/apiRoutes";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import FormEntityLayout from "v4/layouts/FormEntityLayout/FormEntityLayout";
import FullPageFormLayout from "v4/layouts/FullPageFormLayout/FullPageFormLayout";
import ProspectsAddAdditionalButtons
    from "v4/pages/front/Prospects/components/ProspectsAdd/components/ProspectsAddAdditionalButtons/ProspectsAddAdditionalButtons";

export default function ProspectsAdd({type, taskId}) {
    const isBusiness = type === 'business';
    const { getRouteByNativeIdentifier } = useNavigation();

    const fetchFormParameters = useMemo(() => ({
        taskId
    }), [taskId]);

    return <FullPageFormLayout title={isBusiness ? "ajouter_prospect_entreprise" : "add_prospect"}>
        <FormEntityLayout action="add"
                          formRouteName={isBusiness ? PROSPECT_BUSINESS_FORM : PROSPECT_INDIVIDUAL_FORM}
                          submitRouteName={isBusiness ? PROSPECT_BUSINESS_ADD : PROSPECT_INDIVIDUAL_ADD}
                          fetchFormParameters={fetchFormParameters}
                          additionalButtons={
                              isBusiness
                                  ? () => <ProspectsAddAdditionalButtons/>
                                  : null
                          }
                          whenSubmitted={(history, data, methods) => whenSubmitted(history, data, methods, getRouteByNativeIdentifier)}/>
    </FullPageFormLayout>
}

function whenSubmitted(history, data, methods, getRouteByNativeIdentifier) {
    const {redirectToContact} = methods?.getValues() ?? {};
    const {id: prospectId} = data ?? {};
    if (redirectToContact?.value && prospectId) {
        history.push(`/${resolveUrl(getRouteByNativeIdentifier('detail_contacts')?.url, {prospect: prospectId})}/add`, {hasToRefresh: true});

        return;
    }

    history.replace(`/${history.location.pathname.split('/')[1]}`, {hasToRefresh: true});
}
